class LazyloadBackground extends HTMLElement {
  constructor() {
    super()

    this.imageUrl = this.getAttribute('background-image-url')
  }

  connectedCallback() {
    if (this.imageUrl) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.loadBackground(entry);
          }
        });
      });

      this.observer.observe(this);
    }
  }

  loadBackground(entry) {
    const target = entry.target;
    target.style.backgroundImage = `url(${this.imageUrl})`;
    this.observer.unobserve(target);
  }
}

customElements.define('lazyload-background', LazyloadBackground)
